import {connect} from "react-redux";
import MapWrapper from "../components/MapWrapper";
import {addPlace, fetchPlaces, removePlace} from "../actions";

const mapStateToProps = state => {
    const placesMap = {};
    state.places.forEach(place => {
        if (placesMap[place.content_type] === undefined) {
            placesMap[place.content_type] = [];
        }
        placesMap[place.content_type].push(place);
    });

    return {
        places: placesMap,
        path: state.path
    }};

const mapDispatchToProps = dispatch => ({
    fetchPlaces: () => dispatch(fetchPlaces()),
    addPlace: (place, places) => dispatch(addPlace(place, places)),
    removePlace: place => dispatch(removePlace(place))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MapWrapper)
